import { motion } from "framer-motion";
import { MapPin, BedDouble } from "lucide-react";

export default function KostBranchSection({ branch, onPhotoClick }) {
  const mapsUrl = branch.mapsQuery ? `https://www.google.com/maps?q=${branch.mapsQuery}` : null;

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-8" data-testid={`kost-branch-${branch.id}`}>
      <div className="flex items-center gap-3 flex-wrap">
        <h2 className="font-display font-black text-3xl md:text-4xl tracking-tight text-stone-900">Preview {branch.name}</h2>
        {branch.comingSoon && (
          <span data-testid={`kost-branch-${branch.id}-badge`} className="tag-pill bg-amber-100 text-amber-800 border border-amber-300">Segera Hadir</span>
        )}
      </div>
      <p className="text-stone-600 mt-1 flex items-center gap-1.5">
        <MapPin className="w-4 h-4 text-amber-700" /> {branch.address}
      </p>

      {branch.comingSoon ? (
        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              data-testid={`kost-branch-${branch.id}-placeholder-${i}`}
              className={`rounded-3xl border-2 border-dashed border-amber-300 bg-amber-50/60 flex flex-col items-center justify-center text-amber-700 ${i === 0 ? "col-span-2 h-56 md:h-64" : "h-40 md:h-64"}`}
            >
              <BedDouble className="w-6 h-6 mb-2 opacity-60" />
              <span className="font-display font-bold text-xs md:text-sm opacity-70">Foto segera hadir</span>
            </div>
          ))}
        </div>
      ) : (
        <>
          <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3">
            {branch.photos.map((p, i) => (
              <motion.button
                key={i}
                type="button"
                initial={{ opacity: 0, scale: 0.97 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                onClick={() => onPhotoClick(i)}
                className={`group relative rounded-3xl overflow-hidden border border-[#E5DECF] cursor-zoom-in text-left focus:outline-none focus:ring-2 focus:ring-amber-500 ${p.big ? "col-span-2 row-span-2 md:row-span-1" : ""}`}
                data-testid={`kost-branch-${branch.id}-photo-${i}`}
              >
                <img src={p.url} alt={p.caption} className={`w-full object-cover group-hover:scale-105 transition-transform duration-500 ${p.big ? "h-56 md:h-64" : "h-40 md:h-64"}`} />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-900/75 via-transparent to-transparent" />
                <div className="absolute bottom-2.5 left-3 right-3 flex items-center gap-1.5">
                  <p.icon className="w-3.5 h-3.5 text-amber-300 shrink-0" />
                  <span className="font-display font-bold text-white text-xs md:text-sm leading-tight">{p.caption}</span>
                </div>
              </motion.button>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch">
            <iframe
              title={`Lokasi ${branch.name}`}
              data-testid={`kost-branch-${branch.id}-map`}
              src={`https://www.google.com/maps?q=${branch.mapsQuery}&z=17&output=embed`}
              className="w-full h-72 md:h-full min-h-[280px] rounded-3xl border border-[#E5DECF]"
              loading="lazy"
              allowFullScreen
            />
            <div className="rounded-3xl bg-white border border-[#E5DECF] p-6 flex flex-col justify-center">
              <span className="tag-pill bg-amber-100 text-amber-800 w-fit"><MapPin className="w-3 h-3" /> Lokasi</span>
              <h3 className="mt-3 font-display font-bold text-xl text-stone-900">{branch.name}</h3>
              <p className="mt-1 text-sm text-stone-600 leading-relaxed">{branch.address}</p>
              <ul className="mt-3 space-y-1.5 text-sm text-stone-600">
                {branch.facilities.map((f) => (
                  <li key={f}>✓ {f}</li>
                ))}
              </ul>
              <a
                data-testid={`kost-branch-${branch.id}-maps-link`}
                href={mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex w-fit items-center gap-2 px-5 py-2.5 rounded-full bg-amber-700 text-white text-sm font-bold hover:bg-amber-800 transition"
              >
                <MapPin className="w-4 h-4" /> Buka di Google Maps
              </a>
            </div>
          </div>
        </>
      )}
    </section>
  );
}
